<template>
  <div class="add-items-to-checklist-wrapper" v-click-outside='closeTagDropdown'>
    <form @submit.prevent="submitItems()" ref="newItemsForm">
      <div class="relatico-select-wrapper document-types-dropdown">
        <label>{{ userDocumentTypeTitle }}</label>

        <div class="float-right tag-dropdown-wrapper">
          <a @click.prevent='docTagDropdown = true' href='#'>
            {{ $t('checklist.add_to_checklist_modal.filter') }} <i class="fa fa-filter"></i>
          </a>

          <div v-show='docTagDropdown' class="tag-dropdown">
            <multi-select :getter='getTags' v-model='selectedDocTags' />
            <div class="actions">
              <button @click.prevent="filterByDocTags" class="btn btn-primary btn-sm">
                {{ $t('checklist.add_to_checklist_modal.filter_btn') }}
              </button>

              <button @click.prevent='docTagDropdown = false' class="btn btn-outline-primary btn-sm">
                {{ $t('products.list.cancel') }}
              </button>
            </div>
          </div>
        </div>

        <b v-show="docTagParams.length > 0">
          {{ $t('checklist.add_to_checklist_modal.filtering', { count: docTagParams.length }) }}
          (<a href="#" @click.prevent="docTagParams = []">
            {{ $t('checklist.add_to_checklist_modal.show_all') }}
          </a>)
        </b>

        <multi-select ref='docSelect' :getter='getDocumentTypes' v-model='selectedDocTypes' :creator='createDocumentType' />
      </div>

      <div class="relatico-select-wrapper products">
        <label>{{ userProductTitle }}</label>

        <div class="float-right tag-dropdown-wrapper">
          <a @click.prevent='productTagDropdown = true' href='#'>
            {{ $t('checklist.add_to_checklist_modal.filter') }} <i class="fa fa-filter"></i>
          </a>

          <div v-show='productTagDropdown' class="tag-dropdown">
            <multi-select :getter='getTags' v-model='selectedProductTags' />
            <div class="actions">
              <button @click.prevent="filterByProductTags" class="btn btn-primary btn-sm">
                {{ $t('checklist.add_to_checklist_modal.filter_btn') }}
              </button>
              <button @click.prevent='productTagDropdown = false' class="btn btn-outline-primary btn-sm">
                {{ $t('products.list.cancel') }}
              </button>
            </div>
          </div>
        </div>

        <b v-show="productTagParams.length > 0">
          {{ $t('checklist.add_to_checklist_modal.filtering', { count: productTagParams.length }) }}
          (<a href="#" @click.prevent="productTagParams = []">
            {{ $t('checklist.add_to_checklist_modal.show_all') }}
          </a>)
        </b>

        <multi-select ref='prodSelect' :getter='getProducts' v-model='selectedProducts' :creator='createProduct' />
      </div>

      <input type="submit" name="commit" :value="$t('checklist.add')" class="btn btn-primary"/>
    </form>
  </div>
</template>

<script>
  import _infinite_multi_select from '../shared/_infinite_multi_select'

  export default {
    components: {
      'multi-select': _infinite_multi_select,
    },
    props: ['record', 'folder'],
    props: {
      folder: {
        type: Object,
        required: true
      },
      record: {
        type: Object,
        required: true
      },
      resource: {
        type: String,
        default: () => { return null }
      }
    },
    data() {
      return {
        selectedProducts: [],
        selectedDocTypes: [],
        selectedDocTags: [],
        selectedProductTags: [],
        docTagParams: [],
        productTagParams: [],
        docTagDropdown: false,
        productTagDropdown: false,
      }
    },
    computed: {
      productRequestParams() {
        if (this.productTagParams.length == 0)
          return {}

        return { 'filters[tags_id_in]': this.productTagParams }
      },
      documentRequestParams() {
        if (this.docTagParams.length == 0)
          return {}

        return { 'filters[tags_id_in]': this.docTagParams }
      },
    },
    methods: {
      getTags(params) {
        return this.listStore.getTags(params)
      },
      getDocumentTypes(params) {
        return this.listStore.getDocumentTypes(Object.assign({'filters[archive_eq]': false}, this.documentRequestParams, params))
      },
      getProducts(params) {
        return this.listStore.getProducts(Object.assign({'filters[archive_eq]': false}, this.productRequestParams, params))
      },
      createDocumentType(params) {
        return this.store.createDocumentType({ name: params.q })
      },
      createProduct(params) {
        return this.store.createProduct({ name: params.q })
      },
      filterByDocTags() {
        this.docTagParams = this.selectedDocTags.map(t => t.id)
        this.selectedDocTags = []
        this.docTagDropdown = false
        this.$refs.docSelect.open()
      },
      filterByProductTags() {
        this.productTagParams = this.selectedProductTags.map(t => t.id)
        this.selectedProductTags = []
        this.productTagDropdown = false
        this.$refs.prodSelect.open()
      },
      closeTagDropdown() {
        this.docTagDropdown = false
        this.productTagDropdown = false
      },
      submitItems() {
        const isValid = this.selectedProducts.length > 0 && this.selectedDocTypes.length > 0

        if (!isValid) {
          this.$toastr.alert(this.$t('checklist.validate_form_alert'))
          return
        }

        const params = {
          product_ids: this.selectedProducts.map(x => x.id),
          document_type_ids: this.selectedDocTypes.map(x => x.id),
          folder_ids: this.folder.id,
          resource: this.$props.resource
        }

        return this.store.createChecklistItems(params).then(({data}) => {
          this.selectedProducts = []
          this.selectedDocTypes = []
          this.store.sendMetrics({name: 'add_checklist_items_from_record', params: this.$route.params, path: this.$route.fullPath})
          this.store.getCurrentUser()
          this.$toastr.success(data.message)
          this.$emit('success')
        })
      },
    }
  }
</script>

<style lang="sass" scoped>
  .relatico-select-wrapper
    margin-bottom: 20px
    b
      font-size: 12px
      display: block
  .tag-dropdown
    right: 0
    left: auto
    top: 25px
    background-color: #fff
    border: 1px solid #ccc
    border-radius: 3px
    padding: 5px
    position: absolute
    z-index: 20
    width: max-content
    max-width: 415px
    .actions
      text-align: right
  .custom-select
    max-height: initial
    margin-bottom: 15px
</style>
